import { DATE_FORMAT } from "helpers/common";
import Badge from "react-bootstrap/Badge";
import React from "react";
import { Link } from "react-router-dom";
import { Button, Dropdown } from "react-bootstrap";
import { Tooltip } from "react-tooltip";
// import UnControll

// export const selectRow = (props) => ({
//   mode: "checkbox",
//   clickToSelect: true,
//   selectionHeaderRenderer: ({ indeterminate, mode, ...rest }) => (
//     <div className="custom-control custom-checkbox">
//       <input
//         type="checkbox"
//         className="custom-control-input"
//         ref={(input) => {
//           if (input) input.indeterminate = indeterminate
//         }}
//         {...rest}
//       />
//       <label className="custom-control-label">&nbsp;</label>
//     </div>
//   ),
//   selectionRenderer: ({ mode, rowKey, ...rest }) => (
//     <div className="custom-control custom-checkbox" key={rowKey}>
//       <input type="checkbox" className="custom-control-input" {...rest} />
//       <label className="custom-control-label">&nbsp;</label>
//     </div>
//   ),
//   ...props,
// })

const STATUS = {
  active: "Active",
  inactive: "Inactive",
  blocked: "Blocked",
  deleted: "Deleted",
};

const Columns = ({ handleEditHandler }) => [
  {
    dataField: "roundId",
    text: "Round Id",
    formatter: (_, row) => (
      <span className="text-capitalize">
        <Tooltip id="my-tooltip" />
        {row.roundId}
        {row.isRoundMultiplier && (
          <button
            data-tooltip-id="my-tooltip"
            data-tooltip-content="Played by Round Multilplier"
            className="border-0 p-0 bg-transparent"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.288 20.713C11.096 20.521 11 20.2833 11 20V14.4L7.05 18.375C6.85 18.575 6.61267 18.675 6.338 18.675C6.06334 18.675 5.82567 18.575 5.625 18.375C5.42434 18.175 5.32434 17.9377 5.325 17.663C5.32567 17.3883 5.42567 17.1507 5.625 16.95L9.6 13H4C3.71667 13 3.47934 12.904 3.288 12.712C3.09667 12.52 3.00067 12.2827 3 12C2.99934 11.7173 3.09534 11.48 3.288 11.288C3.48067 11.096 3.718 11 4 11H9.6L5.625 7.05C5.425 6.85 5.325 6.61267 5.325 6.338C5.325 6.06334 5.425 5.82567 5.625 5.625C5.825 5.42434 6.06267 5.32434 6.338 5.325C6.61334 5.32567 6.85067 5.42567 7.05 5.625L11 9.6V4C11 3.71667 11.096 3.47934 11.288 3.288C11.48 3.09667 11.7173 3.00067 12 3C12.2827 2.99934 12.5203 3.09534 12.713 3.288C12.9057 3.48067 13.0013 3.718 13 4V9.6L16.95 5.625C17.15 5.425 17.3877 5.325 17.663 5.325C17.9383 5.325 18.1757 5.425 18.375 5.625C18.5743 5.825 18.6743 6.06267 18.675 6.338C18.6757 6.61334 18.5757 6.85067 18.375 7.05L14.4 11H20C20.2833 11 20.521 11.096 20.713 11.288C20.905 11.48 21.0007 11.7173 21 12C20.9993 12.2827 20.9033 12.5203 20.712 12.713C20.5207 12.9057 20.2833 13.0013 20 13H14.4L18.375 16.95C18.575 17.15 18.675 17.3877 18.675 17.663C18.675 17.9383 18.575 18.1757 18.375 18.375C18.175 18.5743 17.9377 18.6743 17.663 18.675C17.3883 18.6757 17.1507 18.5757 16.95 18.375L13 14.4V20C13 20.2833 12.904 20.521 12.712 20.713C12.52 20.905 12.2827 21.0007 12 21C11.7173 20.9993 11.48 20.9043 11.288 20.713Z"
                fill="#7B6EE1"
              ></path>
            </svg>
          </button>
        )}
      </span>
    ),
  },
  {
    dataField: "ID",
    text: "ID",
    formatter: (_, row) => (
      <span className="text-capitalize">{row?.userDetails?.username}</span>
    ),
  },
  {
    dataField: "Username",
    text: "Username",
    formatter: (_, row) => (
      <span className="text-capitalize">
        {row?.userDetails?.telegram_username
          ? row?.userDetails?.telegram_username
          : row?.userDetails?.first_name}
      </span>
    ),
  },
  {
    dataField: "lineCount",
    text: "Line Count",
    formatter: (_, row) => (
      <span className="text-capitalize">{row.lineCount}</span>
    ),
  },

  {
    dataField: "prevEnergyBalance",
    text: "Pre Energy Balance",
    formatter: (_, row) => (
      <span className="text">{row.prevEnergyBalance}</span>
    ),
  },
  // {
  //   dataField: "Winnings",
  //   text: "Winnings",
  //   formatter: (_, row) => <span className="text">
  //     {row?.winnings?.length ? (
  //       row?.winnings?.length === 1 ? (
  //         <div className="d-flex align-items-center">
  //           <span className="icn me-1">
  //             <img
  //               src={row?.winnings?.[0]?.icon}
  //               alt=""
  //               style={{ height: 14, width: 14 }}
  //               className=" img-fluid object-fit-contain"
  //             />
  //           </span>
  //           {row?.winnings?.[0]?.amount || 0}
  //         </div>
  //       ) : (
  //         <Dropdown className={``}>
  //           <Dropdown.Toggle
  //             variant="transparent"
  //             id="dropdown-basic"
  //             className="rounded-2 d-flex align-items-center justify-content-center px-1 border-0"
  //           >
  //             <span className="icn me-1"></span>
  //             See all...
  //           </Dropdown.Toggle>

  //           <Dropdown.Menu
  //             className={` p-0 pb-2`}
  //           >
  //             <ol className="list-unstyled ps-0 mb-0">
  //               {row?.winnings?.map((win, key) => (
  //                 <li
  //                   key={key}
  //                   className="d-flex align-items-center px-2"
  //                 >
  //                   <span className="numb  fw-bold">
  //                     {key + 1}.
  //                   </span>
  //                   <Button
  //                     className="d-flex align-items-center  py-1"
  //                     variant="transparent"
  //                   >
  //                     <span className="icn me-1">
  //                       <img
  //                         src={win?.icon}
  //                         alt=""
  //                         style={{
  //                           height: 14,
  //                           width: 14,
  //                         }}
  //                         className="img-fluid object-fit-contain"
  //                       />
  //                     </span>
  //                     {win?.amount || 0}
  //                   </Button>
  //                 </li>
  //               ))}
  //             </ol>
  //           </Dropdown.Menu>
  //         </Dropdown>
  //       )
  //     ) : (
  //       "--"
  //     )}
  //   </span>,
  // },
  {
    dataField: "Btnc Winnings",
    text: "Btnc Winnings",
    formatter: (_, row) => {
      const btncWinnings = row?.winnings?.find((win) => win.symbol === "BTNC");
      return (
        <span className="text">
          {btncWinnings ? (
            <div className="d-flex align-items-center">
              <span className="icn me-1">
                <img
                  src={btncWinnings.icon}
                  alt={btncWinnings.name}
                  style={{ height: 14, width: 14 }}
                  className="img-fluid object-fit-contain"
                />
              </span>
              {btncWinnings.amount || 0}
            </div>
          ) : (
            <span>0</span>
          )}
        </span>
      );
    },
  },
  {
    dataField: "Crypto Winnings",
    text: "Crypto Winnings",
    formatter: (_, row) => {
      const cryptoWinnings = row?.winnings?.filter(
        (win) => win.symbol !== "BTNC",
      );
      return (
        <span className="text">
          {cryptoWinnings && cryptoWinnings.length > 0 ? (
            <div className="d-flex flex-column">
              {cryptoWinnings.map((win, index) => (
                <div key={index} className="d-flex align-items-center mb-1">
                  <span className="icn me-1">
                    <img
                      src={win.icon}
                      alt={win.name}
                      style={{ height: 14, width: 14 }}
                      className="img-fluid object-fit-contain"
                    />
                  </span>
                  {win.amount || 0}
                </div>
              ))}
            </div>
          ) : (
            <span>--</span>
          )}
        </span>
      );
    },
  },
  {
    dataField: "status",
    text: "status",
    formatter: (_, row) => (
      <span className="text-capitalize">{row?.status}</span>
    ),
  },
  {
    text: "completedAt",
    dataField: "completed At",
    formatter: (_, row) => row.completedAt && DATE_FORMAT(row.completedAt),
  },
  // {
  //   text: "endedAt",
  //   dataField: "ended At",
  //   formatter: (_, row) => row.endedAt && DATE_FORMAT(row.endedAt),
  // },

  {
    text: "Action",
    dataField: "status",
    formatter: (_, row) => (
      <button
        className="fas fa-eye"
        style={{
          fontSize: "16px",
          backgroundColor: "#fff",
          border: "none",
        }}
        title="Edit"
        onClick={() => handleEditHandler(row)}
      ></button>
    ),
  },
];
export default Columns;
